module.exports = __webpack_public_path__ + "img/ic_good.6c5471a6.png";